// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		suggestionMobileStyle: 'style2'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	InstantSearchResult.prototype._applyFilterAutocompleteAppendElement = function() {
		this.appendToSelector = '.search-suggestion-wrapper';
	};



	/* Fix for search results */
    /* Start-Boost-158427 */
    InstantSearchResult.prototype.afterRender = function() {
        jQ('.boost-pfs-search-suggestion-scroll-groups-element-wrapper').append(this.blockViewAll.$element);
    }
    /* End-Boost-158427 */


     /* start-boost-custom #216219  */
    /* #boost-: Customize instant search results */
    InstantSearchApi.beforeCall = function(searchTerm) {
      Globals.instantSearchQueryParams.q = Utils.encodeURIParamValue(unescape(searchTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' '));
      if (!Globals.instantSearchQueryParams.q) Globals.instantSearchQueryParams.q = searchTerm // avoid breaking the search
    }
    
    var searchSubmit = SearchInput.prototype._onSubmit;
      
    SearchInput.prototype._onSubmit = function(event, redirect) {
      searchSubmit.call(this, event, redirect);
      
      var term = unescape(Globals.currentTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' ');
      var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(term);
      
      var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
      
      if (isApiReturnedResult) {
        if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
          Utils.setWindowLocation(redirectUrl);
        } else {
          this.isChangePage = true;
          this.$searchForm[0].submit();
        }
      } 
    }
    /* end-boost-custom #216219*/
})();